export default __webpack_public_path__ + "static/media/relevance.056adba7.jpg";